export const environment = {
  production: false,
  enableDebugLogs: true,
  firebase: {
    apiKey: "AIzaSyAxsMe2CpI53tqd7XOiTalTcOP96jd1PIs",
    authDomain: "dev-impostor-game.firebaseapp.com",
    projectId: "dev-impostor-game",
    storageBucket: "dev-impostor-game.firebasestorage.app",
    messagingSenderId: "505001913703",
    appId: "1:505001913703:web:e3925882e70c20012ed3c2",
    measurementId: "G-EV2FXMTHVR"
  },
  apiKeys: {
    rawg: 'e76583ca3c164186bb04814daea91e8a',
  },
  apiUrls: {
    rawg: 'https://api.rawg.io/api',
    jikan: 'https://api.jikan.moe/v4',
  },
};
